import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  card: {
    width: 640,
    minHeight: 688,
    margin: "auto",
    padding: theme.spacing(3),
    borderRadius: theme.spacing(2),
  },
  title: {
    fontSize: 28,
    marginBottom: theme.spacing(3),
  },
  subtitle: {
    marginBottom: theme.spacing(3),
  },
}));
